import * as React from 'react';

function SvgWildcard(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M14.56 12l4.54-2.44c.24-.13.4-.38.4-.66a.73.73 0 00-.1-.38l-.63-1.05a.77.77 0 00-1.06-.26l-4.43 2.62.11-5.07v-.01a.76.76 0 00-.77-.75h-1.24a.76.76 0 00-.77.75v.02l.11 5.06L6.3 7.21a.77.77 0 00-1.06.26L4.6 8.53a.75.75 0 00.3 1.03L9.44 12 4.9 14.44a.75.75 0 00-.4.66c0 .14.04.26.1.38l.63 1.05a.77.77 0 001.06.26l4.43-2.62-.11 5.06v.02c0 .41.34.75.77.75h1.24c.43 0 .77-.34.77-.75v-.02l-.11-5.06 4.43 2.62a.77.77 0 001.06-.26l.63-1.06a.75.75 0 00-.3-1.03L14.57 12z" />
    </svg>
  );
}

export default SvgWildcard;
